import React from 'react';
import TeamsContainer from '../TeamsContainer';
import { DashboardsCellWrapper } from '../../shared/components';

/**
 * Cell renderer for Dashboards column in WebTeams table
 */
export const WebDashboardsCell = ({
  data,
  dashboardsById,
  setDialog,
  addHomepageMenuItems,
  onMenuItemClick
}) => {
  const handleMenuItemClick = (e, label) => {
    onMenuItemClick(e, label, data.teamId);
  };

  return (
    <DashboardsCellWrapper
      Container={TeamsContainer}
      items={data.dashboards}
      itemsById={dashboardsById}
      teamId={data.teamId}
      setDialog={setDialog}
      showAddButton={true}
      addButtonConfig={{
        menuItems: addHomepageMenuItems,
        onItemClick: handleMenuItemClick,
        dataTestId: 'add-dashboard-button'
      }}
    />
  );
};
